const permissions = {
  MANAGE_TENANTS: "ManageTenants",
  MANAGE_TENANTS_READ: "ManageTenants.Read",
  MANAGE_TENANTS_WRITE: "ManageTenants.Write",
  MANAGE_TENANTS_DELETE: "ManageTenants.Delete",

  MANAGE_USERS: "ManageUsers",
  MANAGE_USERS_READ: "ManageUsers.Read",
  MANAGE_USERS_WRITE: "ManageUsers.Write",
  MANAGE_USERS_DELETE: "ManageUsers.Delete",

  MANAGE_APPLICATIONS: "ManageApplications",
  MANAGE_APPLICATIONS_READ: "ManageApplications.Read",
  MANAGE_APPLICATIONS_WRITE: "ManageApplications.Write",
  MANAGE_APPLICATIONS_DELETE: "ManageApplications.Delete",
  MANAGE_APPLICATIONS_REGENERATE_CREDENTIALS: "ManageApplications.RegenerateCredentials",

  MANAGE_CONFIGURATIONS: "ManageConfigurations",
  MANAGE_CONFIGURATIONS_READ: "ManageConfigurations.Read",
  MANAGE_CONFIGURATIONS_WRITE: "ManageConfigurations.Write",
  MANAGE_CONFIGURATIONS_DELETE: "ManageConfigurations.Delete",

  MANAGE_TENANT_APPLICATIONS: "ManageTenantApplications",
  MANAGE_TENANT_APPLICATIONS_READ: "ManageTenantApplications.Read",
  MANAGE_TENANT_APPLICATIONS_WRITE: "ManageTenantApplications.Write",
  MANAGE_TENANT_APPLICATIONS_DELETE: "ManageTenantApplications.Delete",
} as const;

export default permissions;

export type permissionValues = typeof permissions[keyof typeof permissions];
